import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Contents} from "../../../components";
import PrevIcon from "../../../../assets/images/icon/PrevIcon";
import {AddChapter, Col, FormBox, ProfileFormBoxItemWrap, FormItem, Row} from "../../../../styled/StyledComponent";
import {teachersAPI} from "../../../../api/teachersAPI";

const EditIdPopup = (props) => {
    const [changeData, setChangeData] = useState({
        email:"",
        password:"",
    })
    const [verifyCode, setVerifyCode] = useState("");
    const [render, setRender] = useState(false)
    const [renderCode, setRenderCode] = useState(false);
    const [editPage ,setEdit] = useState(false);
    const postEmail = async () => {
        await teachersAPI.postChangeEmail({
            data:{
                newEmail:changeData.email,
                password:changeData.password
            }
        })
            .then(res => {
                console.log("@res",res);
                if(res?.success === true){
                    setEdit(true)
                    setTimeout(()=>{
                        setRender(false)
                    },300)
                }else{
                    alert("error")
                }
            })
    };

    const [error, setError] = useState(false);
    const postChangeEmail = async () => {
        await teachersAPI.getTeacherEmailCheck(changeData.email)
            .then(res => {
                // if(res?.data)
                const value = Object.values(res?.data)
                console.log("@value",value);
                if(value.findIndex(item => item === true) !== -1){
                    console.log("@error");
                    setError(true)
                }else{
                    console.log("@suc",);
                    setError(false)
                    postEmail()
                }
            })
    };
    const postVerifyCode = async () => {

        await teachersAPI.postCodeVerify({
            data:{
                code:verifyCode,
                newEmail:changeData.email,
            }
        })
            .then(res => {
                if(res?.success === true){

                    props.getProfile();
                    setChangeData({
                        email:"",
                        password:"",
                    })
                    setVerifyCode("")
                    props.onToastPopup();
                    props.onClickPopup();
                }else{
                    alert("error")
                }
            })
    }

    useEffect(() => {
        setTimeout(()=> {
            setEdit(false)
            setTimeout(()=>{
                setRender(true)
            },100)
        },100)
    }, []);

return(
  <Container>
    <Contents title={render === true ? "Edit Account" : "Code Verification"}>
        {/*"Code Verification"*/}
        {
            editPage === false ?
                <Inner className={render === true ? "on" : ""}>
                <BackButton
                    onClick={()=>{
                        setChangeData({
                            email:"",
                            password:"",
                        })
                        setVerifyCode("")
                        props.onClickPopup();
                    }}
                >
                    <PrevIcon/>
                    <span>
                    Back
                </span>
                </BackButton>
                <h1>
                    Add a new email
                </h1>
                <Row display={"flex"} style={{width: "100%", alignItems:"center"}}>
                    <Col className={"col"} style={{width: "80%",}}>
                        <FormBox>
                            <dt>
                                Enter new email address
                            </dt>
                            <dd>
                                <ProfileFormBoxItemWrap>
                                    <li>
                                        <FormItem>
                                            <input
                                                className={error ? "error" : ""}
                                                autoComplete="nope2"
                                                onChange={(e)=>{
                                                    setChangeData({
                                                        ...changeData,
                                                        email:e.target.value
                                                    })
                                                }}
                                                value={changeData.email}
                                                type="text" placeholder={"Email"}/>
                                        </FormItem>
                                        {
                                            error &&
                                            <p style={{marginTop: 5, color: "#ea4335", opacity: 0.8}}>Duplicate email
                                                address</p>
                                        }
                                    </li>
                                </ProfileFormBoxItemWrap>
                            </dd>
                        </FormBox>

                    </Col>
                </Row>

                <Row display={"flex"} style={{width: "100%", alignItems:"center"}}>
                    <Col className={"col"} style={{width: "80%",}}>
                        <FormBox>
                            <dt>
                                Enter your Whoflex password
                            </dt>
                            <dd>
                                <ProfileFormBoxItemWrap>
                                    <li>
                                        <FormItem>
                                            <input
                                                onChange={(e)=>{
                                                    setChangeData({
                                                        ...changeData,
                                                        password:e.target.value
                                                    })
                                                }}
                                                autoComplete="new-password"
                                                value={changeData.password}
                                                type="password" placeholder={"Password"}/>
                                        </FormItem>
                                    </li>
                                </ProfileFormBoxItemWrap>
                            </dd>
                        </FormBox>
                    </Col>
                </Row>
                <AddChapter
                    onClick={()=>{
                        postChangeEmail()
                    }}
                >
                <span style={{marginRight:0}} >
                    Submit
                </span>
                </AddChapter>
            </Inner> :
                <Inner className={render === false ? "on" : ""}>
                <BackButton
                    onClick={()=>{
                        setEdit(false)
                        setTimeout(()=>{
                            setRender(true)
                        },300)
                    }}
                >
                    <PrevIcon/>
                    <span>
                    Back
                </span>
                </BackButton>
                <h1>
                    We sent a code to your email
                </h1>
                <Row display={"flex"} style={{width: "100%", alignItems: "center"}}>
                    <Col className={"col"} style={{width: "80%",}}>
                        <FormBox>
                            <dt style={{marginBottom: 10}}>
                                Enter the 6-digit code sent to <b>{changeData.email}</b> <span
                                onClick={()=>{
                                    setEdit(false)
                                    setTimeout(()=>{
                                        setRender(true)
                                    },300)
                                }}
                                style={{
                                color: "#DDC160CC", fontWeight: 700, textDecoration: "underline", marginLeft: 10,
                                    cursor:"pointer"
                            }}>Change</span>
                            </dt>
                            <dd>
                                <ProfileFormBoxItemWrap>
                                    <li>
                                        <FormItem>
                                            <input
                                                type="text"
                                                autoComplete={"off"}
                                                onChange={(e)=>{
                                                    setVerifyCode(e.target.value)
                                                }}
                                                value={verifyCode}
                                                placeholder={"6-digit code"}/>
                                        </FormItem>
                                    </li>
                                </ProfileFormBoxItemWrap>
                            </dd>
                            <span className={"resend"}
                            onClick={()=>{
                                postChangeEmail();
                            }}
                            >
                           Resend Code
                        </span>
                        </FormBox>
                    </Col>
                </Row>
                <AddChapter onClick={postVerifyCode}>
                <span style={{marginRight: 0}}>
                    Submit
                </span>
                </AddChapter>
                <p className={"guide"}>If you don’t see the email in your inbox, check your spam folder.</p>
            </Inner>
        }
    </Contents>

  </Container>
)

}
export default EditIdPopup;

const Container = styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -65%);
    width: 700px;
    @media screen and (max-width: 768px) {
        width: 96%;
        .col{
            width: 100% !important;
        }
    }
   
    
    
    .commonContents{
        overflow: hidden;
    }
    h1{
        font-family: Europa-Bold;
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0em;
        text-align: left;
        color: #333;
        margin-bottom: 40px;
    }
`;
const BackButton = styled.div`
    font-family: Europa-Regular;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0em;
    text-align: left;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 20px;
    span{
       margin-left: 10px; 
       color: #5A5A5A;
   }
`
const Inner = styled.div`
    padding: 20px;
    transition: all 0.2s;
    transform: translateX(-10%);
    opacity: 0;
    &.on{
        transform: none;
        opacity: 1;
    }
    .resend{
        font-family: Europa-Bold;
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        color: #DDC160CC;
        cursor: pointer;
    }
    .guide{
        font-family: Europa-Regular;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        color: #33333399;
    }
`